import './CustomerModal.css';
import OfferModal from '../offerModal/OfferModal';

import {Button, CloseButton, Modal} from '@deere/ux.uxframe-react';
import PropTypes from 'prop-types';
import React from 'react';

const CustomModal = (props) => {
  const onBackButtonEvent = (e) => {
    e.preventDefault();
    props.closeHandler();
  };

  React.useEffect(() => {
    if (props.isVisible) {
      window.history.pushState(null, null, window.location.pathname);
      window.history.pushState(null, null, window.location.pathname);
      window.addEventListener('popstate', onBackButtonEvent);
      return () => window.removeEventListener('popstate', onBackButtonEvent);
    }
  }, []);

  return (
    <Modal
      className={`CustomModal ${props.customClass ? props.customClass : ''}`}
      centered={true}
      show={props.isVisible}
      onHide={() => {}}
    >
      <Modal.Header className={props.headerClass ? props.headerClass : ''}>
        <Modal.Title className={props.titleClass ? props.titleClass : ''}>
          {props.title}
        </Modal.Title>
        {!props.hideCloseButton && <CloseButton onClick={props.closeHandler} />}
      </Modal.Header>
      <Modal.Body className={props.bodyClass ? props.bodyClass : ''}>
        <div className={props.subtitleClass ? props.subtitleClass : ''}>
          {props.subTitle}
        </div>
        {props.subTitleSecondary ? (
          <div
            className={
              props.subTitleSecondaryClass ? props.subTitleSecondaryClass : ''
            }
          >
            {props.subTitleSecondary}
          </div>
        ) : null}
        <div className="flagOuterBox">
          {props.imageSelect
            ? props.imageSelect.map((el) => (
                <div
                  key={el.countryName}
                  className={`flagBox ${
                    props.selectFlagClass === el.countryName ? 'addBorder' : ''
                  }`}
                  onClick={() => props.imageCallback(el.countryName)}
                >
                  <img className="countryFlag" src={el.flag} />
                  <div className="countryName">{el.countryName}</div>
                </div>
              ))
            : null}
        </div>
        {props.bodyContent ? (
          <OfferModal
            bodyContent={props.bodyContent}
            modalBtnClass={'offerSubmitBtn'}
            onSubmitModel={props.onSubmitModel}
            btnName={props.btnName}
          />
        ) : null}
      </Modal.Body>
      {!props.removeFooter && (
        <Modal.Footer className={props.footerClass ? props.footerClass : ''}>
          <Button
            className={props.secondaryClickHandler ? '' : 'secondaryButton'}
            id={
              props.secondaryClickHandlerId ? props.secondaryClickHandlerId : ''
            }
            variant="secondary"
            onClick={props.secondaryClickHandler}
          >
            {props.secondaryButtonText}
          </Button>

          <Button
            variant="primary"
            className={
              props.primaryClickHandler ? props.className : 'secondaryButton'
            }
            id={props.primaryClickHandlerId ? props.primaryClickHandlerId : ''}
            disabled={props.primaryButtonDisabled}
            onClick={props.primaryClickHandler}
          >
            {props.primaryButtonText}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};
CustomModal.defaultProps = {
  closeHandler: () => {},
};

CustomModal.propTypes = {
  isVisible: PropTypes.bool,
  customClass: PropTypes.string,
  headerClass: PropTypes.string,
  titleClass: PropTypes.string,
  title: PropTypes.node,
  hideCloseButton: PropTypes.bool,
  closeHandler: PropTypes.func,
  bodyClass: PropTypes.string,
  subtitleClass: PropTypes.string,
  subTitle: PropTypes.node,
  subTitleSecondary: PropTypes.node,
  subTitleSecondaryClass: PropTypes.string,
  imageSelect: PropTypes.arrayOf(
    PropTypes.shape({
      countryName: PropTypes.string,
      flag: PropTypes.string,
    })
  ),
  selectFlagClass: PropTypes.string,
  imageCallback: PropTypes.func,
  bodyContent: PropTypes.node,
  onSubmitModel: PropTypes.func,
  btnName: PropTypes.string,
  removeFooter: PropTypes.bool,
  footerClass: PropTypes.string,
  secondaryClickHandler: PropTypes.func,
  secondaryClickHandlerId: PropTypes.string,
  secondaryButtonText: PropTypes.node,
  primaryClickHandler: PropTypes.func,
  primaryClickHandlerId: PropTypes.string,
  primaryButtonDisabled: PropTypes.bool,
  primaryButtonText: PropTypes.node,
  className: PropTypes.string,
};

export default CustomModal;
